import {
  ElasticSearchResponse,
  FurnitureImageNameDescription,
  FurnitureImageNameDescriptionDocument,
} from '@shared/services/elastic-search/models';

export const furnituresImageNameDescriptionSerializer = (
  furnituresImageNameDescription: ElasticSearchResponse<FurnitureImageNameDescriptionDocument>
): FurnitureImageNameDescription[] =>
  furnituresImageNameDescription.hits.hits.map((furniture) => {
    const source = furniture._source;
    return {
      title: source.title?.[0] ?? '',
      height: source.field_furniture_height?.[0] ?? '',
      width: source.field_furniture_width?.[0] ?? '',
      image: source.field_images?.[0] ?? undefined!,
    };
  });
